import { Button, ButtonProps } from "@chakra-ui/react";
import { t } from "i18next";
import { useNavigate } from "react-router";
import { useSlideInMenu } from "../slideInMenu/hooks/useSlideInMenu";

interface ClaimWithGoldButtonProps extends Omit<ButtonProps, "onClick" | "variant"> {
  /**
   * Parent-provided click hook. Runs BEFORE we navigate, in case the parent
   * needs to track an impression / call an analytics event. The default
   * navigation always runs after (cannot be cancelled).
   */
  onBeforeNavigate?: () => void;
}

/**
 * Shared "Claim" button used wherever a claimable Gold Monthly release is
 * rendered (release-details slide-in, hero cards, feature cards). Only shown
 * to Gold users — non-Gold users see the regular buy / subscribe CTA. The
 * button doesn't actually claim; it closes any open slide-in and deep-links
 * to the rewards hub where the user completes the claim.
 */
export function ClaimWithGoldButton({ onBeforeNavigate, ...rest }: ClaimWithGoldButtonProps) {
  const navigate = useNavigate();
  const { onCloseMenu } = useSlideInMenu();
  return (
    <Button
      variant="primary"
      gc-testing-id="btnClaimFromReleaseCard"
      {...rest}
      onClick={() => {
        onBeforeNavigate?.();
        onCloseMenu();
        navigate("/my-shelf/gold-rewards");
      }}
    >
      {t("screens.monthlyComics.claim")}
    </Button>
  );
}
